<template>
  <div class="search-section">
    <div class="input-wrapper">
      <span class="back" @click="$emit('back')"
        ><img src="@/assets/images/back.png" alt="back"
      /></span>
      <div class="search">
        <input
          class="search-input"
          type="text"
          placeholder="請輸入地址與區域"
          v-model.trim="searchContent"
          @input="$emit('search', searchContent)"
          @blur="isInputBlur = false"
          @focus="isInputBlur = true"
        />
        <div class="drop-down" v-if="isInputBlur && searchContent && matchedStores.length > 0">
          <div
            class="location"
            v-for="(storeInfo, index) in matchedStores"
            :key="index"
          >
            <img src="../assets/images/site.png" alt="" />
            <span class="address">{{ storeInfo.properties.address }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="card-wrapper">
      <!-- storeServicePeriods 沒對到，要再改 -->
      <InfoCard
        :storeInfo="storeInfo"
        :storeServicePeriods="storeServicePeriods[index]"
        v-for="(storeInfo, index) in matchedStores"
        :key="index"
      ></InfoCard>
    </div>
    <!-- <div class="history">
      <div class="history-header">
        <span class="title">最近搜尋</span>
        <span class="clear">清除</span>
      </div>
      <div class="history-body">
        <h3>新北市中正路</h3>
        <h3>新北市中正路</h3>
      </div>
    </div> -->
  </div>
</template>

<script>
import InfoCard from "@/components/InfoCard";
export default {
  props: {
    matchedStores: {
      type: Array,
      required: true
    },
    storeServicePeriods: {
      type: Array,
      required: true
    }
  },
  components: {
    InfoCard
  },
  data() {
    return {
      searchContent: "",
      isInputBlur: false
    };
  },
  beforeDestroy() {
    this.searchContent = "";
    this.isInputBlur = false;
    this.$emit("search", this.searchContent);
  }
};
</script>

<style lang="scss" scoped>
.search-section {
  position: absolute;
  height: 100%;
  width: 375px;
  background-color: #fafafa;
  z-index: 20;
  .input-wrapper {
    display: flex;
    height: 10%;
    align-items: center;
    padding: 15px;
  }
  input {
    width: 310px;
    height: 46px;
    padding: 0 15px;
    border: 1px solid #34495e33;
    border-radius: 10px;
    vertical-align: middle;
    outline: none;
    &::placeholder {
      color: #566778;
      opacity: 0.4;
    }
  }
  .back {
    display: inline-block;
    width: 10%;
    vertical-align: middle;
    cursor: pointer;
    img {
      width: 20px;
    }
  }
}

.search {
  position: relative;
  .drop-down {
    position: absolute;
    width: 100%;
    max-height: 210px;
    overflow: scroll;
    top: 100%;
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0px 10px 20px #00000036;
    border: 1px solid #34495e33;
    z-index: 10;
  }
  .location {
    display: flex;
    align-items: center;
    padding: 10px 5px;
    color: #566778;
    cursor: pointer;
  }
}

.card-wrapper {
  height: 85%;
  padding: 20px 0;
  overflow: scroll;
}

// .history {
//   &-header {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     padding: 8px 15px;
//     color: #fff;
//     font-size: 12px;
//     background: #34495e;
//     .clear {
//       width: 52px;
//       height: 26px;
//       line-height: 24px;
//       text-align: center;
//       border: 2px solid #fafafa;
//       border-radius: 100px;
//       opacity: 0.8;
//       cursor: pointer;
//     }
//   }
//   &-body {
//     padding: 5px 15px;
//     h3 {
//       padding: 15px 10px;
//       color: #34495e;
//       font-size: 14px;
//       font-weight: 400;
//       border-bottom: 1px solid #d2d7db;
//     }
//   }
// }
</style>
